import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_3 = { class: "card-body p-xl-40" }
const _hoisted_4 = { class: "row g-3 align-items-center" }
const _hoisted_5 = { class: "col-lg-8" }
const _hoisted_6 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_7 = {
  type: "button",
  class: "btn style-two px-4 h-55",
  "data-bs-toggle": "modal",
  "data-bs-target": "#adjustmentFilterModal"
}
const _hoisted_8 = { class: "search-box position-relative" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = { class: "d-flex justify-content-lg-end" }
const _hoisted_12 = {
  class: "modal fade",
  id: "adjustmentFilterModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_13 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_14 = { class: "modal-content border-0 shadow" }
const _hoisted_15 = { class: "modal-header border-bottom-dashed" }
const _hoisted_16 = { class: "modal-title fw-bold" }
const _hoisted_17 = ["aria-label"]
const _hoisted_18 = { class: "modal-body" }
const _hoisted_19 = { class: "row g-3" }
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "form-label fs-14 text-title" }
const _hoisted_22 = { value: "" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "modal-footer border-top-dashed justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AdjustmentList = _resolveComponent("AdjustmentList")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_DetailsModal = _resolveComponent("DetailsModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, { pageTitle: "adjustment_list" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_ctx.$t("adjustment_page.filter")) + " ", 1),
                  _cache[4] || (_cache[4] = _createElementVNode("i", { class: "ri-filter-line ms-1" }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                    placeholder: _ctx.$t('adjustment_page.search_placeholder'),
                    class: "form-control bg-white h-55 shadow-none pe-5"
                  }, null, 8, _hoisted_9), [
                    [_vModelText, _ctx.searchQuery]
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "search-icon" }, [
                    _createElementVNode("i", { class: "ri-search-line" })
                  ], -1))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_router_link, {
                  to: "/create-adjustment",
                  class: "btn style-one d-inline-flex align-items-center h-55 px-4"
                }, {
                  default: _withCtx(() => [
                    _cache[6] || (_cache[6] = _createElementVNode("i", { class: "ri-add-circle-line me-1" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("create_adjustment")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_AdjustmentList, {
        adjustments: _ctx.adjustments,
        loading: _ctx.loading,
        onViewDetails: _ctx.handleViewDetails,
        onDeleteAdjustment: _ctx.handleDeleteAdjustment
      }, null, 8, ["adjustments", "loading", "onViewDetails", "onDeleteAdjustment"]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h5", _hoisted_16, _toDisplayString(_ctx.$t("adjustment_page.advanced_filter")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close shadow-none",
              "data-bs-dismiss": "modal",
              "aria-label": _ctx.$t('common.close')
            }, null, 8, _hoisted_17)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("adjustment_page.warehouse")), 1),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select bg-light border-0 fs-14 shadow-none",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.warehouse_id) = $event))
                }, [
                  _createElementVNode("option", _hoisted_22, _toDisplayString(_ctx.$t("adjustment_page.all_warehouses")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouses, (w) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: w.id,
                      value: w.id
                    }, _toDisplayString(w.name), 9, _hoisted_23))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.filters.warehouse_id]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-light",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
            }, _toDisplayString(_ctx.$t("adjustment_page.reset")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
            }, _toDisplayString(_ctx.$t("adjustment_page.apply_filter")), 1)
          ])
        ])
      ])
    ]),
    _createVNode(_component_DetailsModal, {
      adjustment: _ctx.selectedAdjustment,
      loading: _ctx.detailsLoading
    }, null, 8, ["adjustment", "loading"])
  ], 64))
}